// auth.config.ts
import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'environments/environment';

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.authConfig.authority,
    showDebugInformation: true,
    redirectUri: environment.authConfig.redirectUrl,
    postLogoutRedirectUri: environment.authConfig.postLogoutRedirectUri,
    clientId: environment.authConfig.clientId,
    scope: environment.authConfig.scope,
    responseType: environment.authConfig.responseType,
    useSilentRefresh: true,
    
};
